import React from 'react';
import { database } from '../data/database.ts';

const Services: React.FC = () => {

  const db = database.services;

  return (
    <section id="services" className="services section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-xl-center gy-5">

          <div className="col-xl-12 content">
            <h2 className="section-title">{db.title}</h2>
          </div>

          <div className="col-xl-12">
            <div className="row gy-4 icon-boxes">
              {
                db.items.map((item, index) => (
                  <div key={index} className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <div 
                      style={{'backgroundImage': `url(${item.image})`, 'backgroundSize': 'cover'}} className="icon-box">
                      <i className={item.icon}></i>
                      <h3>{item.name}</h3>
                      <p>{item.description}</p>
                    </div>
                    <div className="overlay"></div>
                  </div>
                ))
              }
            </div>
          </div>

        </div>
      </div>

    </section>
  );
};

export default Services;
